import React from "react";
import { getSecondaryOfficials } from "./officialRoles";
import { AvailableOfficialsList } from "./AvailableOfficialsList.jsx";
import { Text, View,} from "@react-pdf/renderer";

export const FixtureReportsFooter = ({ roles, intl }) => {
  const { formatMessage } = intl;
  const officialRoles = getSecondaryOfficials();
  const availableOfficials = roles.reduce((acc, role) => {
    if (officialRoles.includes(role.role)) {
      if (!acc[role.role]) {
        acc[role.role] = [];
      }
      acc[role.role].push(role);
    }
    return acc;
  }, {});
  const reportGeneratedAt = Intl.DateTimeFormat(undefined, {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(new Date());

  return (
    <View>
      <View>
        <AvailableOfficialsList availableOfficials={availableOfficials} intl={intl} />
      </View>
      <View>
        <View style={{ alignItems: "flex-end", fontFamily: ["Noto Sans", "Noto Sans TC"], fontSize: 7.7 }}>
          <View style={{ alignItems: "flex-start", flexDirection: "column" }}>
            <Text>
              {formatMessage({
                id: "reports.header.reportgenerated",
                defaultMessage: "Report generated:",
              })}
            </Text>
            <Text style={{ fontWeight: "bold" }}>{reportGeneratedAt}</Text>
          </View>
        </View>
      </View>
    </View>
  );
};
